<div class="card">
  <div class="card-header">
    <h3 class="card-title">Payments Report</h3>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table
        class="table table-hover table-striped text-nowrap table-vcenter mb-0"
      >
        <thead>
          <tr>
            <th>Project</th>
            <th>Earned Value</th>
            <th>Gross Billed</th>
            <th>Amount Paid</th>
            <th>Last Paid On</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="report.length == 0">
            No data found
          </tr>
          <tr *ngFor="let reportRow of report">
            <td>{{ reportRow.project?.contractTitle }}</td>
            <td>QR {{ reportRow.earnedValue }}</td>
            <td>QR {{ reportRow.accumulatedGrossAmount }}</td>
            <td>QR {{ reportRow.cumulativeReceivedAmount }}</td>
            <td>{{ reportRow.lastReceivedDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
